(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('FlyerCategoryFactory', FlyerCategoryFactory);

    FlyerCategoryFactory.$inject = ['$resource'];

    function FlyerCategoryFactory ($resource) {
        var resourceUrl =  'flyer/api/category/:key';

        return $resource(resourceUrl, {}, {
            'listAllByCurrentStore': {
                url: 'flyer/api/category/current-store',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listAllByStoreHub': {
                url: 'flyer/api/category/store-hub',
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'query': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getJSON': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listAll': {
                url: 'flyer/api/category/list',
                method: 'POST',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'getData': {
                method: 'GET',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = data;
                    response.headers = headers();
                    return response;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' },
            'createByStore': {
                method: 'POST',
                url: 'flyer/api/category/store',
                transformResponse: function (data, headers) {
                    var response = {};
                    if (data) {
                        response.data = angular.fromJson(data);
                    }
                    response.headers = headers();
                    return response;
                }
            },
            'listCategoriesByStoreId': {
                method: 'GET',
                url: 'flyer/api/category/store/:storeId',
                transformResponse: function (data, headers) {
                    var response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'listCategoriesWithFlyers': {
                method: 'POST',
                url: 'flyer/api/category/flyers',
                transformResponse: function(data, headers) {
                  var response = {};
                  response.data = angular.fromJson(data);
                  response.headers = headers();
                  return response;
                }
            },
        });
    }
})();
